module.exports = __webpack_public_path__ + "img/banner_miniapp.ac440b8d.png";